import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@mui/material';

import { useCalculateTotal } from '../../../../hooks/useCalculateTotal';
import FormLayoutGenerator, { FieldConfig } from '../../../FormLayoutGenerator';
import { useCalculatePercentage } from '../hooks/useCalculatePercentage';

export const FIELDS: FieldConfig[] = [
  {
    label: 'holidays_label',
    name: 'finEHolidaysPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'holidays_label',
    name: 'finEHolidaysBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'special_leave_label',
    name: 'finESpecialleavePrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'special_leave_label',
    name: 'finESpecialleaveBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'education_label',
    name: 'finESchoolingPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'education_label',
    name: 'finESchoolingBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'training_label',
    name: 'finETrainingPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'training_label',
    name: 'finETrainingBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'festive_days_label',
    name: 'finEFestivedaysPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'festive_days_label',
    name: 'finEFestivedaysBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'illness_label',
    name: 'finEIllPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'illness_label',
    name: 'finEIllBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'various_own_label',
    name: 'finEVariousownPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'various_own_label',
    name: 'finEVariousownBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'age_hours_label',
    name: 'finEAgehoursPrc',
    type: 'text',
    cols: 6
  },
  {
    label: 'age_hours_label',
    name: 'finEAgehoursBuhPrc',
    type: 'text',
    cols: 6
  },

  { label: 'total_nph_label', name: 'totalNph', disabled: true, cols: 6 },
  { label: 'total_nph_label', name: 'totalNphBuh', disabled: true, cols: 6 },

  {
    label: 'percentage_uplift_label',
    name: 'percentageUplift',
    type: 'text',
    disabled: true,
    cols: 6
  },
  {
    label: 'percentage_uplift_label',
    name: 'percentageUpliftBuh',
    type: 'text',
    disabled: true,
    cols: 6
  }
];

const NonProductiveHours = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.surcharges'
  });

  useCalculateTotal(
    [
      'finEHolidaysPrc',
      'finESpecialleavePrc',
      'finESchoolingPrc',
      'finETrainingPrc',
      'finEFestivedaysPrc',
      'finEIllPrc',
      'finEVariousownPrc',
      'finEAgehoursPrc'
    ],
    'totalNph'
  );

  useCalculateTotal(
    [
      'finEHolidaysBuhPrc',
      'finESpecialleaveBuhPrc',
      'finESchoolingBuhPrc',
      'finETrainingBuhPrc',
      'finEFestivedaysBuhPrc',
      'finEIllBuhPrc',
      'finEVariousownBuhPrc',
      'finEAgehoursBuhPrc'
    ],
    'totalNphBuh'
  );

  useCalculatePercentage('totalNph', 'percentageUplift');
  useCalculatePercentage('totalNphBuh', 'percentageUpliftBuh');

  return (
    <>
      <Grid item xs={6}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t('work_header')}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t('buh_header')}
        </Typography>
      </Grid>
      <FormLayoutGenerator
        fieldConfigs={FIELDS}
        translateKeyPrefix="employerCostSettings"
      />
    </>
  );
};

export default NonProductiveHours;
